import React from "react";
import { Link } from "react-router-dom";
import AkkhorLayout from "../layout/akkhor";
import { CONTRACT_SYSTEM_PARAMS, toPlaceholder } from "./contractParams";

const formatExamples = [
    { label: "Giữ nguyên dữ liệu", param: "{fullname}" },
    { label: "Viết hoa toàn bộ", param: "{fullname:upper}" },
    { label: "Viết thường toàn bộ", param: "{fullname:lower}" },
    { label: "Viết hoa chữ cái đầu từng từ", param: "{fullname:title}" },
];

const customParamExamples = [
    { label: "Lương chính thức", param: "{luongchinhthuc}" },
    { label: "Ca làm việc sáng", param: "{calamviecsang}" },
    { label: "Ca làm việc chiều", param: "{calamviecchieu}" },
    { label: "Địa điểm làm việc riêng", param: "{diadiemlamviec}" },
];

const commonErrors = [
    {
        issue: "File merge vẫn còn {fullname}",
        reason: "File Word dùng sai tham số hoặc mẫu chưa lưu lại params mới",
        solution: "Copy lại tham số từ giao diện, dán vào Word, upload lại mẫu",
    },
    {
        issue: "Tham số tùy biến không hiện ở màn tạo hợp đồng",
        reason: "Chưa khai báo tham số tùy biến trong mẫu hợp đồng",
        solution: "Mở mẫu hợp đồng, thêm tham số tùy biến, lưu lại",
    },
    {
        issue: "Thông tin công ty/người đại diện bị trống",
        reason: "Dữ liệu công ty chưa có mã số thuế, người đại diện hoặc chức vụ",
        solution: "Cập nhật thông tin trong danh mục công ty/nhân sự/chức vụ",
    },
    {
        issue: "Ngày tháng hiển thị sai định dạng",
        reason: "Dữ liệu ngày trong hồ sơ nhân sự chưa đúng",
        solution: "Kiểm tra lại hồ sơ nhân sự",
    },
    {
        issue: "Không xem được file",
        reason: "File chưa upload xong hoặc đường dẫn file lỗi",
        solution: "Lưu lại hợp đồng/mẫu hợp đồng và thử mở lại",
    },
];

const checklist = [
    "File Word đã có đầy đủ placeholder.",
    "Các placeholder được copy đúng từ giao diện.",
    "Mẫu hợp đồng đã được upload và lưu thành công.",
    "Đã thử tạo ít nhất một hợp đồng với nhân sự mẫu.",
    "Nếu import Excel, đã chọn loại hợp đồng trên giao diện và file đã có cột {code} cùng các cột tùy biến đúng placeholder.",
    "File merge mở được và các thông tin chính đã thay đúng.",
    "Các tham số tùy biến đã hiện và nhập được khi tạo hợp đồng.",
];

export default function HuongDanSuDung() {
    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>Hướng dẫn sử dụng hợp đồng</li>
                </ul>
            </div>

            <div className="card height-auto">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Hướng dẫn sử dụng Service Hợp đồng</h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-12 form-group">
                            <h5>1. Khái niệm cần nắm</h5>
                            <ol className="mb-0">
                                <li>Tạo mẫu hợp đồng và upload file Word mẫu.</li>
                                <li>Copy tham số hệ thống dán vào đúng vị trí trong file Word.</li>
                                <li>Khai báo thêm tham số tùy biến nếu mẫu cần thông tin ngoài dữ liệu nhân sự.</li>
                                <li>Tạo hợp đồng, chọn mẫu hợp đồng và chọn nhân sự.</li>
                                <li>Lưu để hệ thống merge dữ liệu vào file Word.</li>
                            </ol>
                        </div>

                        <div className="col-lg-6 col-12 form-group">
                            <h5>2. Cách đặt tham số trong Word</h5>
                            <p className="mb-2">Tham số cần đặt đúng định dạng:</p>
                            <pre className="bg-light border rounded p-3 mb-2"><code>{"{ten_tham_so}"}</code></pre>
                            <p className="mb-1">Ví dụ:</p>
                            <pre className="bg-light border rounded p-3 mb-0"><code>{[
                                "Họ và tên người lao động: {fullname}",
                                "Mã nhân viên: {code}",
                                "Phòng ban: {departmentname}",
                                "Công ty: {companyname}",
                                "Mức lương chính thức: {luongchinhthuc}",
                            ].join("\n")}</code></pre>
                        </div>
                    </div>

                    <hr />

                    <div className="row">
                        <div className="col-lg-6 col-12 form-group">
                            <h5>3. Định dạng chữ hoa/chữ thường</h5>
                            <p>
                                Nếu cần cùng một thông tin nhưng hiển thị theo nhiều kiểu chữ khác nhau,
                                chọn tùy chọn copy ở nút mũi tên bên cạnh tham số.
                            </p>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered align-middle">
                                    <thead>
                                        <tr>
                                            <th>Nhu cầu</th>
                                            <th>Tham số dán vào Word</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formatExamples.map((item) => (
                                            <tr key={item.param}>
                                                <td>{item.label}</td>
                                                <td><code>{item.param}</code></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="col-lg-6 col-12 form-group">
                            <h5>4. Tham số tùy biến</h5>
                            <p>
                                Tham số tùy biến dùng khi file Word cần thông tin không có sẵn trong hồ sơ nhân sự,
                                ví dụ lương, ca làm việc hoặc địa điểm làm việc riêng.
                            </p>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered align-middle">
                                    <thead>
                                        <tr>
                                            <th>Nội dung cần điền</th>
                                            <th>Tham số gợi ý</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {customParamExamples.map((item) => (
                                            <tr key={item.param}>
                                                <td>{item.label}</td>
                                                <td><code>{item.param}</code></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 form-group">
                            <div className="d-flex flex-wrap align-items-center justify-content-between mb-2">
                                <h5 className="mb-1">5. Tham số hệ thống</h5>
                                <Link className="btn btn-sm btn-outline-primary" to="/add-mau-hop-dong">
                                    Tạo mẫu hợp đồng
                                </Link>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered align-middle">
                                    <thead>
                                        <tr>
                                            <th style={{ width: "35%" }}>Dữ liệu</th>
                                            <th>Tham số dán vào Word</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {CONTRACT_SYSTEM_PARAMS.map((item) => (
                                            <tr key={item.title}>
                                                <td>{item.label}</td>
                                                <td><code>{toPlaceholder(item.title)}</code></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-12 form-group">
                            <h5>6. Tạo mẫu hợp đồng</h5>
                            <ol>
                                <li>Vào <b>Mẫu hợp đồng</b>.</li>
                                <li>Bấm <b>Thêm mới</b>.</li>
                                <li>Nhập <b>Tên mẫu</b>.</li>
                                <li>Chọn loại file Word: <code>.docx</code> hoặc <code>.doc</code>.</li>
                                <li>Upload file Word mẫu đã gắn placeholder.</li>
                                <li>Kiểm tra lại danh sách tham số hệ thống và tham số tùy biến.</li>
                                <li>Bấm <b>Lưu lại</b>.</li>
                            </ol>
                            <Link className="btn btn-sm btn-outline-primary" to="/add-mau-hop-dong">
                                Tạo mẫu hợp đồng
                            </Link>
                        </div>

                        <div className="col-lg-6 col-12 form-group">
                            <h5>7. Tạo hợp đồng cho nhân sự</h5>
                            <ol>
                                <li>Vào menu <b>Hợp đồng</b>.</li>
                                <li>Bấm <b>Thêm mới</b>.</li>
                                <li>Nhập tên văn bản - hợp đồng.</li>
                                <li>Chọn nhân sự áp dụng.</li>
                                <li>Chọn mẫu văn bản - hợp đồng.</li>
                                <li>Nhập giá trị tham số tùy biến nếu có.</li>
                                <li>Bấm <b>Lưu lại</b>.</li>
                            </ol>
                            <Link className="btn btn-sm btn-success" to="/add-hop-dong">
                                Tạo hợp đồng
                            </Link>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 form-group">
                            <h5>8. Import nhiều hợp đồng từ Excel</h5>
                            <p className="mb-2">
                                Mỗi dòng Excel tương ứng một hợp đồng. Hệ thống sẽ tìm nhân sự theo mã nhân viên,
                                dùng loại hợp đồng đã chọn trên giao diện import, sau đó merge dữ liệu hệ thống và tham số tùy biến.
                            </p>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered align-middle">
                                    <thead>
                                        <tr>
                                            <th>Cột Excel</th>
                                            <th>Ý nghĩa</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><code>{"{code}"}</code></td>
                                            <td>Mã nhân viên trong hồ sơ nhân sự</td>
                                        </tr>
                                        <tr>
                                            <td><code>{"{luongchinhthuc}"}</code>, <code>{"{calamviec}"}</code></td>
                                            <td>Các tham số tùy biến đã khai báo trong mẫu hợp đồng</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <p className="text-muted mb-2">
                                Loại hợp đồng được chọn trực tiếp trên giao diện import và áp dụng cho toàn bộ file.
                            </p>
                            <div className="d-flex flex-wrap" style={{ gap: 8 }}>
                                <Link className="btn btn-sm btn-outline-success" to="/import-hop-dong">
                                    Import hợp đồng
                                </Link>
                                <a className="btn btn-sm btn-outline-secondary" href="/mau-import-hop-dong.xlsx" download>
                                    Tải file Excel mẫu
                                </a>
                            </div>
                        </div>
                    </div>

                    <hr />

                    <div className="row">
                        <div className="col-12 form-group">
                            <h5>9. Xem file mẫu và file đã merge</h5>
                            <ul>
                                <li><b>Xem mẫu văn bản - hợp đồng</b>: xem file Word mẫu trước khi merge.</li>
                                <li><b>Xem file</b> hoặc khu vực preview file: xem file hợp đồng đã merge.</li>
                            </ul>
                            <p className="mb-0">
                                Nếu preview không hiển thị đúng như Word gốc, có thể mở file trong tab mới hoặc tải file về để kiểm tra bằng Microsoft Word.
                            </p>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12 form-group">
                            <h5>10. Các lỗi thường gặp</h5>
                            <div className="table-responsive">
                                <table className="table table-sm table-bordered align-middle">
                                    <thead>
                                        <tr>
                                            <th>Hiện tượng</th>
                                            <th>Nguyên nhân thường gặp</th>
                                            <th>Cách xử lý</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {commonErrors.map((item) => (
                                            <tr key={item.issue}>
                                                <td>{item.issue}</td>
                                                <td>{item.reason}</td>
                                                <td>{item.solution}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-6 col-12 form-group">
                            <h5>11. Nguyên tắc đặt tên tham số</h5>
                            <ul>
                                <li>Dùng chữ không dấu, viết liền hoặc gạch dưới.</li>
                                <li>Đặt tên ngắn gọn và rõ nghĩa.</li>
                                <li>Không đặt tên có dấu tiếng Việt.</li>
                                <li>Không đặt tên có khoảng trắng.</li>
                                <li>Không đặt tên trùng tham số hệ thống nếu ý nghĩa khác nhau.</li>
                            </ul>
                        </div>
                        <div className="col-lg-6 col-12 form-group">
                            <h5>12. Checklist trước khi đưa mẫu vào sử dụng</h5>
                            <ul>
                                {checklist.map((item) => (
                                    <li key={item}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </AkkhorLayout>
    );
}
